import React from 'react';

import useAppContext from 'flow/hooks/useAppContext';
import Spacer from 'flow/components/custom-components/spacer';
import PbxActiveCallItem from 'flow/components/pbx/PbxActiveCallItem';
import CentralSwitchHeader from 'flow/components/central-switch/CentralSwitchHeader';
import CentralSwitchEmptyState from 'flow/components/central-switch/CentralSwitchEmptyState';
import { CallRecordKey } from 'flow/types/EntityKeys';
import { selectKeysForOngoingQueueCallsInQueuesMarkedAsFavorite } from 'flow/selectors/favorite-selectors';
import { useAppSelector } from 'flow/hooks/useRedux';

const MAX_NUMBER_CALLS_DISPLAY = 4;

const FavoritePbxOngoingCallCentralSwitchWidget = () => {
    const { i18next } = useAppContext();

    const activeQueueCalls = useAppSelector(
        selectKeysForOngoingQueueCallsInQueuesMarkedAsFavorite,
    );

    const shouldDisplayAdditionalActiveCallsItem =
        activeQueueCalls?.size > MAX_NUMBER_CALLS_DISPLAY;
    const additionalActiveCallsNumber = shouldDisplayAdditionalActiveCallsItem
        ? activeQueueCalls?.size - MAX_NUMBER_CALLS_DISPLAY
        : undefined;

    const renderAdditionalQueueItemsText = () => {
        return (
            <>
                <Spacer
                    height={shouldDisplayAdditionalActiveCallsItem ? 24 : 6}
                />
                {shouldDisplayAdditionalActiveCallsItem ? (
                    <div>
                        {i18next.t('calls.queue.more', {
                            number: additionalActiveCallsNumber,
                        })}
                    </div>
                ) : null}
            </>
        );
    };

    const renderOngoingCalls = () => {
        const slicedActiveQueueCalls = activeQueueCalls?.slice(
            0,
            MAX_NUMBER_CALLS_DISPLAY,
        );

        if (!slicedActiveQueueCalls?.size) {
            return (
                <CentralSwitchEmptyState
                    uniqueId={'FavoritePbxItemsOngoingCalls'}
                />
            );
        }
        return (
            <main className="px-4">
                {slicedActiveQueueCalls
                    .map((callKey: CallRecordKey) => {
                        return (
                            <div key={callKey}>
                                <PbxActiveCallItem
                                    callKey={callKey}
                                    isOmniErrand={false}
                                />
                                {renderAdditionalQueueItemsText()}
                            </div>
                        );
                    })
                    .toArray()}
            </main>
        );
    };

    return (
        <>
            <CentralSwitchHeader>
                {i18next.t('central_switch.favorite_pbx_ongoing_calls.title')}
            </CentralSwitchHeader>
            {renderOngoingCalls()}
        </>
    );
};

export default FavoritePbxOngoingCallCentralSwitchWidget;
